export default "__VITE_ASSET__Bjy6P09Y__"